<template>
	<div>

		<!-- 活动规则 -->
		<div class="div_rules" :style="{zIndex:showRules}" :key="Date.now()">
			<div class="rules_view">
				<img class="bg_rules" src="../../assets/bg_rules.png" alt="" />
				<div :class="showRules? 'bg_view' : '' ">
					<div v-html="content"></div>
				</div>
				<img class="close" @click="showRules = -1" src="../../assets/btn_close.png" alt="" />
			</div>
		</div>
		<div class="div_rank" :style="{zIndex:showRank}" :key="Date.now()">
			<div class="rank_view">
				<img class="bg_rank" src="../../assets/bg_rank.png" alt="" />
				<img class="close" @click="showRank = -1" src="../../assets/btn_close.png" alt="" />
				<img class="rank_top" src="../../assets/rank_top.png" alt="" />
				<div class="rank_list_box" v-if="rankList.length > 0">
					<div class="rank_list_item" v-for="(item,index) in rankList" :key="index">
						<div class="ranking">{{item.ranking}}</div>
						<div class="name">{{item.user_nick_name ? item.user_nick_name : '微信用户'}}</div>
						<div class="time">{{ item.score }}</div>
					</div>
				</div>
				<div v-else class="no_rank">暂无数据</div>
				<div class="my_rank">
					<div class="ranking">{{myList.ranking ? myList.ranking : '无'}}</div>
					<div class="name">{{myList.user_nick_name ? myList.user_nick_name : '我'}}</div>
					<div class="time">{{ myList.score ? myList.score : '-' }}</div>
				</div>
			</div>
		</div>
		<div class="index-body" :class="proportion < 0.56 ? 'auto' : 'hidden'">
			<!-- <div style="width: 100px;height: 50px;position: absolute;bottom: 0;right: 0;z-index: 999;" @click="showCo"></div> -->
			<img class="title_index" src="../../assets/title_index.png" alt="" />
			<img class="index_bottom" v-if="proportion < 0.56" src="../../assets/index_bottom.png" alt="" />
			<img class="btn_rules" @click="toRules" src="../../assets/btn_rules.png" alt="" />
			<img class="btn_share" @click="showShare = true" src="../../assets/btn_share.png" alt="" />

			<!-- <van-overlay :show="showTest" z-index="98" style="backdrop-filter:blur(4px)">
				<div style="position: absolute;top: 0;left: 0;width: 100%;height: 100px;overflow: hidden;overflow-y: auto;color:#fff">
					<div v-html="content"></div>
				</div>
			</van-overlay> -->
			<div class="btn_view">
				<div class="btn_item" @click="toGames">
					<img class="btn_item_img" src="../../assets/btn_1.png" alt="" />
					<!-- <span>开始游戏</span> -->
				</div>
				<div class="btn_item" @click="showGoods = true">
					<img class="btn_item_img" src="../../assets/btn_2.png" alt="" />
					<!-- <span>奖品介绍</span> -->
				</div>
				<div class="btn_item" @click="rankVisble">
					<img class="btn_item_img" src="../../assets/btn_3.png" alt="" />
					<!-- <span>排行榜</span> -->
				</div>
				<div class="btn_item" @click="toGoods">
					<img class="btn_item_img" src="../../assets/btn_4.png" alt="" />
					<!-- <span>我的奖品</span> -->
				</div>
			</div>
			<!-- 奖品弹窗 -->
			<van-overlay :show="showGoods" z-index="95" style="backdrop-filter:blur(4px)">
				<div class="goods_view">
					<img class="pop_goods" src="../../assets/pop_goods.png" alt="" />
					<img class="close" @click="showGoods = false" src="../../assets/btn_close.png" alt="" />
				</div>
			</van-overlay>



			<!-- 我的奖品 -->
			<van-overlay :show="showMyPrize" z-index="97" style="backdrop-filter:blur(4px)">
				<div class="prize_view">
					<img class="bg_prize" src="../../assets/bg_goods.png" alt="" />
					<img class="close" @click="showMyPrize = false" src="../../assets/btn_close.png" alt="" />
					<div class="goods_list">
						<div :class="item.win_goods_type == 10 ? 'big-item' : 'small-item'"
							v-for="(item,index) in prizeList" :key="index">
							<div class="item">
								<img :src="item.win_goods_pic" alt="" class="img">
								<div class="center">
									<span class="text name">
										<span class="goods_name">{{item.win_goods_name}}</span>
										<div class="status"
											:class="item.win_goods_type == 10 ? 'big-status' : 'small-status'">
											<span>{{ item.statusTxt }}</span>
										</div>
									</span>
									<span class="text">来源：大转盘抽奖</span>
									<span class="text">中奖编号：{{ item.log_id }}</span>
									<span class="text">中奖时间：{{ item.scan_time }}</span>
								</div>
							</div>
							<div class="line" v-if="item.btnTxt == '立即领取' || item.btnTxt == '重新领取'"></div>
							<div class="bottom" v-if="item.btnTxt == '立即领取' || item.btnTxt == '重新领取'">
								<span>领奖有效期截至：{{receive_etime}}</span>
								<img v-if="item.btnTxt == '立即领取'" @click="clickBtn(index)"
									src="../../assets/btn_list_lq.png" alt="" />
								<img v-if="item.btnTxt == '重新领取'" @click="clickBtn(index)"
									src="../../assets/btn_list_cxlq.png" alt="" />
							</div>
						</div>
						<!-- 空状态 -->
						<div class="empty" v-if="isEmpty">
							<span>暂时还没有您的数据</span>
						</div>
					</div>
				</div>
			</van-overlay>

			<!-- 排行榜 -->
			<!-- <van-overlay :show="showRank" z-index="98" style="backdrop-filter:blur(4px)">
				
			</van-overlay> -->
			<!-- 显示分享 -->
			<van-overlay :show="showShare" z-index="99" @click="showShare = false">
				<div class="share_view">
					<img class="to_share" src="../../assets/to_share.png" alt="" />
				</div>
			</van-overlay>



		</div>
	</div>
</template>
<script>
	import {
		getWinGoods
	} from '../../../static/js/common.js'
	export default {
		components: {
			// LoadingPage
		},
		data() {
			return {
				proportion: window.innerWidth / window.innerHeight,
				show: false,
				content: '',
				startShow: true,
				showPrizeList: false,
				prizeDetail: {},
				showGoods: false,
				showRules: -1,
				showMyPrize: false,
				showRank: -1,
				showShare: false,
				rankList: [],
				prizeList: [],
				myList: {},
				receive_etime: '', // 领奖截止时间
				showTest: false,
				isEmpty: true,
				code: '',
				console: 0,
				loginTime: 0
			}
		},
		//  这里主要不能放在 created() 里
		mounted() {
			console.log(this.proportion)
		},
		created() {
			console.log(jm, jm.user_id, '用户信息')
			sessionStorage.setItem('index', 'isIndex')
			console.log('添加信息', sessionStorage.getItem('index'));
			this.receive_etime = jm.getStorageItem('receive_etime')
			this.getQy()
			this.getContent()
			this.code = new URLSearchParams(window.location.search).get('code')
			console.log(this.code, '从链接上获取的参数')
		},
		methods: {
			showCo() {
				this.console++
				if (this.console >= 10) {
					var vConsole = new VConsole();
					console.log(jm.typecode)
				}
			},
			toRules() {
				this.showRules = 100
				// this.showTest = true
				this.getContent()
			},
			// 点击按钮
			clickBtn(index) {
				let d = this.prizeList[index];
				console.log(d, '点击按钮');
				switch (d.receiveType) {
					case 1: // 领取实物
						this.isPrizeShow = true;
						this.winGoodsInfo = d;
						break;
					case 2: // 查看实物的领取信息
						this.isPrizeDetailShow = true;
						this.$axios.get(jm.site.ACTJEXTRA + "/api/v1/act/win/goods/detail/" + d.log_id).then(res => {
							if (res.success && res.data) {
								this.prizeDetailInfo = res.data;
							}
						})
						break;
					case 3: // 重新领取红包
						this.againReceive(d.log_id)
						break;
					case 4: // 查看优惠券
						this.receiveCoupon(d)
						break;
					case 5: // 领取积分 
						this.getJf(d.log_id)
						break
					default:
						break;
				}
			},
			async getJf(log_id) {
				const res = await this.$axios.post(jm.site.THIRTY + '/api/v1/hongqi/game/api-goods/receive', {
					log_ids: log_id
				})
				if (res.code == 200) {
					this.getPrizeList()
				} else {
					jm.showMsg(res.msg)
				}
			},
			// 获取是否有抽奖几回
			getQy() {
				const that = this
				this.$axios.get(jm.site.usercenterSite + '/api/v1/user/seniority', {
					member_id: 'SEN26012314134721',
					user_id: jm.user_id
				}).then(res => {
					console.log(res.data[0].total_count, res.data[0].used_count)
				})
			},
			rankVisble() {
				this.showRank = 100
				const that = this
				const data = {
					limit: 20
				}
				that.$axios.post(jm.site.THIRTY + '/api/v1/hongqi/game/score-rank-top5', data).then(res => {
					console.log(res, '排名')
					that.myList = res.data.cur_user ? res.data.cur_user : []
					that.rankList = res.data.top_users ? res.data.top_users : []
				})
			},
			toGoods() {
				const that = this
				this.getPrizeList()
				this.$nextTick(() => {
					that.showMyPrize = true
				})
				// this.$router.push({
				// 	path: '/Pictures'
				// })
			},
			toGames() {
				const that = this
				if (jm.getApiToken()) {
					this.$axios.post(jm.site.THIRTY + '/api/v1/hongqi/game/today-participation-count').then(res => {
						console.log(res.data, '今日剩余参加活动次数')
						if (res.code == 200) {
							if (res.data > 0) {
								that.$axios.post(jm.site.THIRTY + '/api/v1/hongqi/game/participation').then((res2) => {
									if (res2.data) {
										window.localStorage.setItem('game_id',res2.data)
										that.$router.push({
											path: '/Games?id=' + window.localStorage.getItem('game_id')
										})
									} else {
										jm.showMsg('获取游戏次数失败，请重新进入活动页面')
									}

								})
							} else {
								jm.showMsg('今天的活动次数用完啦，明天再试试吧')
								console.log('无抽奖次数')
							}
						} else {
							jm.showMsg(res.msg)
						}
					})
				} else {
					setInterval(() => {
						that.loginTime++
						if (that.loginTime > 5) {
							jm.showMsg('登录失败，请刷新页面重试')
						} else {
							jm.showMsg('登录中，请稍等！')
						}
					}, 1000)

				}
			},
			toInfo() {
				this.$router.push({
					path: '/Info',
					query: {
						log_id: this.prizeDetail.log_id
					}
				})
			},
			getPrizeDetail(log_id) {
				this.$axios.get(jm.site.ACTJEXTRA + "/api/v1/act/win/goods/detail/" + log_id).then(res => {
					this.isLoading = false
					if (res.success && res.data) {
						this.prizeDetail = {}
						this.prizeDetail = res.data
						console.log('抽奖信息', res.data);
					}
				})
			},
			getReceiveCouponList() {
				this.$axios.get(jm.site.THIRTY + '/api/v1/pepsicola/winlog/receive/log', {
					params: {
						pageNum: 1,
						pageSize: 999
					},
				}).then(res => {
					let list = []
					if (res.success && res.data) {
						list = [...res.data]
					} else {
						list = []
					}

					this.prizeList.forEach(item => {
						if (item.win_goods_type != 40) return

						let findData = list.find(f => f.log_id == item.log_id)
						if (findData) {
							item.showBtn = false
						} else {
							item.showBtn = true
						}
					})

					this.prizeList = [...this.prizeList]
				})
			},
			// 重新领取
			againReceive(log_id) {
				if (this.isLoading == true) return;
				this.isLoading = true;
				this.$axios.post(jm.site.ACTJEXTRA + '/api/v1/act/win/goods/5051goods/receive', this.$qs.stringify({
					log_id
				}), {
					headers: {
						"content-type": "application/x-www-form-urlencoded;charset=UTF-8"
					}
				}).then(data => {
					this.isLoading = false;
					if (data.success) {
						if (data.data.grant_status == false) {
							if (data.data.cash_server_fail_reason) {
								jm.showMsg(data.data.cash_server_fail_reason)
							} else {
								jm.showMsg("领取失败，请稍后再试")
							}
						}
						if (data.data.grant_status == true) {
							if (data.data.cash_grant_type == 2) {
								wx.ready(() => {
									wx.checkJsApi({
										jsApiList: ['requestMerchantTransfer'],
										success: function(res) {
											if (res.checkResult['requestMerchantTransfer']) {
												WeixinJSBridge.invoke(
													'requestMerchantTransfer', {
														mchId: data.data
															.transferorder_bind_mchno,
														appId: jm.site.appId,
														package: data.data.packageinfo,
													},
													function(res) {
														if (res.err_msg ===
															'requestMerchantTransfer:ok') {
															// res.err_msg将在页面展示成功后返回应用时返回success，并不代表付款成功
														}
													}
												);
											} else {
												alert('你的微信版本过低，请更新至最新版本。');
											}
										}
									});
								});
							} else {
								jm.showMsg('领取成功')
							}
						}
					} else {
						jm.showMsg(data.msg)
					}
				})
			},
			fifterStatus(item) {
				let obj = {
					statusTxt: "", //状态文字描述
					showBtn: false, //是否显示操作按钮
					btnTxt: "", //按钮上的文字
					receiveType: "", //领奖类型 1-领取实物 2-查看实物 3-领取红包 4-查看优惠券
					glink: "", //跳转链接
				};

				let nowTime = new Date().getTime()
				let receive_etime = new Date(this.receive_etime.replace(/-/g, "/")).getTime()

				switch (item.grant_status) {
					case 5: //裂变奖品，等待好友领取后可领取
						obj.statusTxt = "待发放";
						obj.btnTxt = "查看详情";
						break;
					case 10: //未发放
						obj.statusTxt = "待发放";
						obj.btnTxt = "立即领取";
						obj.grant_status = nowTime >= receive_etime ? -20 : item.grant_status

						if (item.win_goods_type == 10) {
							obj.showBtn = true;
							obj.statusTxt = "待领取";
							obj.receiveType = 1;
						} else if (item.win_goods_type == 50 || item.win_goods_type == 51) {
							obj.showBtn = true;
							obj.statusTxt = "待领取";
							obj.receiveType = 3;
						} else if (item.win_goods_type == 160) {
							obj.showBtn = true;
							obj.statusTxt = "待领取";
							obj.receiveType = 5;
						}
						break;
					case 11: //等待选择奖品领取，裂变奖品中，用户可自行选择一个奖品
						obj.statusTxt = "等待选取";
						obj.btnTxt = "立即选取";
						obj.showBtn = false;
						break;
					case 111: //待提交审核资料
						obj.statusTxt = "待提交审核资料";
						obj.btnTxt = "填写资料";
						obj.showBtn = false;
						break;
					case 12:
						obj.statusTxt = "待审核";
						obj.showBtn = false;
						break;
					case 20: //红包、微信支付、流量、话费
						obj.statusTxt = "发放中";
						obj.showBtn = item.win_goods_type == 50 || item.win_goods_type == 51 ? true : false;
						obj.btnTxt = "重新领取";
						obj.receiveType = 3;
						break;
					case 21: //实物已领取(实物奖品)
						obj.statusTxt = item.win_goods_type == 10 ? '待发放' : "已领取";
						obj.showBtn = true;
						obj.btnTxt = "查看详情"
						obj.receiveType = 2;
						break;
					case 30:
						obj.statusTxt = "发放成功";
						if (item.win_goods_type == 10) {
							obj.receiveType = 2
							obj.btnTxt = "查看详情";
							obj.showBtn = true;
						} else if (item.win_goods_type == 40 && item.win_goods_sub_type == 45) {
							obj.receiveType = 4
							obj.btnTxt = "立即领取";
							obj.showBtn = true;
						}
						break;
					case -10: //红包，微信支付，流量，话费类型奖品
						obj.statusTxt = "发放失败";
						obj.btnTxt = "重新领取";
						obj.showBtn = true;
						obj.receiveType = 3;
						obj.grant_status = nowTime >= receive_etime ? -20 : item.grant_status
						break;
					case -20: //红包、微信支付、流量、话费、资格卡券等奖品
						obj.statusTxt = "已过期";
						obj.showBtn = false;
						break;
					case -30:
						obj.statusTxt = "审核不通过";
						obj.showBtn = false;
						break;
					default:
						break;
				}
				return obj;
			},

			// 查询我的奖品列表
			getPrizeList() {
				this.isLoading = true

				let params = this.actcodes ? {
					act_codes: this.actcodes
				} : null;
				getWinGoods(this, null, params).then(res => {
					this.isLoading = false

					if (res && res.success && res.data && res.data.length) {
						this.isEmpty = false
						this.prizeList = res.data;
						this.prizeList.forEach(t => {
							let obj = this.fifterStatus(t);
							Object.keys(obj).map(k => {
								t[k] = obj[k]
							})
						});
					} else {
						this.prizeList = []
						this.isEmpty = true
					}

					this.getReceiveCouponList()
				})
			},
			toPaiZhao() {
				this.$router.push({
					path: '/Pictures'
				})
			},
			getContent() {
				this.$axios.get(jm.site.ACTJEXTRA + '/api/v1/act/copywritingcontent', {
					params: {
						act_code: localStorage.getItem('act')
					},
				}).then(res => {
					console.log(res)
					if (res.success && res.data) {
						this.content = res.data.copywriting_content
						// this.$nextTick(() => {
						// 	this.initRulesScroll()
						// })

					}
				})
			},
			// 新增：初始化活动规则滚动区域
			initRulesScroll() {
				const rulesScrollBox = document.querySelector('.rules_view .bg_view')
				console.log(rulesScrollBox)
				if (!rulesScrollBox) return

				// 1. 强制触发浏览器重绘，重新计算滚动容器尺寸
				rulesScrollBox.style.display = 'none'
				void rulesScrollBox.offsetHeight // 触发重绘
				rulesScrollBox.style.display = 'block'

				// 2. 手动设置滚动属性（兜底，防止CSS样式未生效）
				rulesScrollBox.style.overflowY = 'auto'
				rulesScrollBox.style.webkitOverflowScrolling = 'touch'
				rulesScrollBox.style.touchAction = 'pan-y'

				// 3. 可选：重置滚动位置到顶部，提升用户体验
				rulesScrollBox.scrollTop = 0
				// this.showRules = true
			}
		},
	}
</script>

<style lang="scss" scoped>
	.rank_view {
		width: 17.375rem;
		height: 21.35rem;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		font-size: 0.8rem;

		.bg_rank {
			width: 17.375rem;
			height: 21.35rem;
		}

		.rank_top {
			position: absolute;
			top: 3.25rem;
			left: 50%;
			margin-left: -6.975rem;
			width: 13.95rem;
			height: 3.7rem;
			border-bottom: 1px solid #7d0603;
			padding-bottom: .7rem;
		}

		.no_rank {
			position: absolute;
			top: 50%;
			left: 0;
			text-align: center;
			width: 100%;
		}

		.rank_list_box {
			width: 13.95rem;
			height: 10.85rem;
			position: absolute;
			bottom: 3.55rem;
			left: 50%;
			margin-left: -6.975rem;
			font-weight: 700;
			/* 修复：滚动属性移到父容器，这是核心滚动区域 */
			overflow: hidden;
			overflow-y: auto;
			-webkit-overflow-scrolling: touch;
			touch-action: pan-y;
			box-sizing: border-box;

			.rank_list_item {
				display: flex;
				justify-content: space-between;
				width: 13.95rem;
				height: 2.7rem;
				line-height: 2.7rem;
				text-align: center;
				border-bottom: 2px dashed #ba0a04;
				color: #7d0603;
				/* 移除：子项不需要滚动属性，删除原有overflow相关配置 */

				.ranking {
					width: 3.15rem;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}

				.name {
					flex: 1;
					width: 3.15rem;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}

				.time {
					width: 3.325rem;
					width: 3.15rem;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}

				&:last-child {
					border: 0px;
				}
			}
		}

		.my_rank {
			width: 16.35rem;
			height: 3rem;
			position: absolute;
			bottom: 0;
			left: 50%;
			margin-left: -8.175rem;
			border-radius: 0 0 1rem 1rem;
			background: #FFAC1E;
			box-sizing: border-box;
			padding: 0 1.2rem;
			display: flex;
			text-align: center;
			line-height: 3rem;
			color: #fff;
			font-weight: 900;

			.ranking {
				width: 3.15rem;
				width: 3.15rem;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			.name {
				flex: 1;
				width: 3.15rem;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			.time {
				width: 3.325rem;
				width: 3.15rem;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}
		}

		.close {
			position: absolute;
			top: 1.15rem;
			right: .8rem;
			transform: translate(-50%, 0);
			width: .8rem;
			height: .8rem;
		}
	}

	.div_rank {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, .7);
		backdrop-filter: blur(4px)
	}

	.div_rules {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, .7);
		backdrop-filter: blur(4px)
	}

	.rules_view {
		width: 17.35rem;
		height: 22.9rem;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);

		.bg_rules {
			width: 17.35rem;
			height: 22.9rem;

		}

		.bg_view {
			width: 14.75rem;
			height: 18.8rem;
			position: absolute;
			top: 3.1rem;
			left: 50%;
			margin-left: -7.375rem;
			border-radius: .8rem;
			background: #ffffff;
			overflow: hidden;
			overflow-y: auto;
			padding: .4rem;
			box-sizing: border-box;
		}

		.close {
			position: absolute;
			top: 1.15rem;
			right: .8rem;
			transform: translate(-50%, 0);
			width: .8rem;
			height: .8rem;
		}
	}

	.index-body {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		overflow: hidden;
		background: linear-gradient(360deg, #191B3F 0%, #412A64 100%);

		.btn_rules {
			position: absolute;
			top: 1rem;
			left: 1rem;
			width: 2rem;
			height: 2rem;
		}

		.btn_share {
			position: absolute;
			top: 1rem;
			right: 1rem;
			width: 2rem;
			height: 2rem;
		}

		.title_index {
			position: absolute;
			width: 18.75rem;
			height: 9.2rem;
			top: .5rem;
			left: 50%;
			margin-left: -9.375rem;
		}

		.index_bottom {
			position: absolute;
			bottom: 0;
			left: 0;
			width: 100%;
			height: 7.8rem;
		}

		.btn_view {
			width: 10.6rem;
			height: 15.8rem;
			position: absolute;
			top: 10.4rem;
			left: 50%;
			margin-left: -5.3rem;
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			.btn_item {
				position: relative;
				width: 10.6rem;
				height: 2.9rem;

				img {
					width: 100%;
					height: 100%;
				}

				span {
					width: 100%;
					height: 100%;
					text-align: center;
					position: absolute;
					top: 0;
					left: 0;
					color: #ffffff;
					line-height: 2.9rem;
					-webkit-text-stroke: 1px #E87002;
					/* 标准写法（部分浏览器已支持） */
					text-stroke: 0.0125rem #E87002;
					font-size: 1.1rem;
					font-weight: 900;
				}
			}
		}

		.goods_view {
			width: 17.375rem;
			height: 14.6rem;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);

			.pop_goods {
				width: 100%;
				height: 100%;
			}

			.close {
				position: absolute;
				top: 1.15rem;
				right: .8rem;
				transform: translate(-50%, 0);
				width: .8rem;
				height: .8rem;
			}
		}



		.prize_view {
			width: 16.475rem;
			height: 17.2rem;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);

			.bg_prize {
				width: 16.475rem;
				height: 17.2rem;
			}

			.goods_list {
				height: 13.1rem;
				width: 15.15rem;
				position: absolute;
				top: 3.1rem;
				left: 50%;
				margin-left: -7.575rem;
				overflow: hidden;
				overflow-y: auto;
				-webkit-overflow-scrolling: touch;
				touch-action: pan-y;
				padding: 0 .4rem;
				box-sizing: border-box;

				/* 新增：确保内边距不溢出容器高度 */
				.small-item {
					background: #FFFFFF;
					border-radius: 0.8rem;
					margin-bottom: .4rem;
					padding: .4rem;
					box-sizing: border-box;
				}

				.empty {
					width: 100%;
					// height: 100%;
					margin-top: 1rem;
				}

				.line {
					width: 100%;
					height: 1px;
					background: #FFE0BA;
					margin-top: 0.7rem;
					margin-bottom: .4rem;
				}

				.bottom {
					display: flex;
					justify-content: space-between;
					color: #810000;

					span {
						font-size: 0.55rem;
						line-height: 1.6rem;
					}

					img {
						width: 3.5rem;
						height: 1.6rem;
					}
				}

				.item {
					width: 100%;
					// height: 4.8rem;
					display: flex;
					/* 新增：避免内边距撑高容器 */

					.img {
						width: 3.6rem;
						height: 3.6rem;
					}

					.center {
						display: flex;
						flex-direction: column;
						font-size: .5rem;
						margin-left: .4rem;
						color: #810000;
						flex: 1;

						.text {
							margin-bottom: .1rem;
						}

						.name {
							font-size: 0.7rem;
							margin-bottom: .4rem;
							color: #BA0A04;
							display: flex;
							justify-content: space-between;
							align-items: center;

							.goods_name {
								font-weight: 600 !important;
							}
						}
					}

					.status {
						width: 2.8rem;
						display: inline-block;
						font-size: 0.6rem;
					}
				}

				.empty {
					text-align: center;
					color: #810000;
					font-size: .7rem;
				}
			}

			.close {
				position: absolute;
				top: 1.15rem;
				right: .8rem;
				transform: translate(-50%, 0);
				width: .8rem;
				height: .8rem;
			}
		}



		.share_view {
			width: 18.75rem;
			height: 9.8rem;
			position: absolute;
			top: .5rem;
			left: 50%;
			margin-left: -9.375rem;

			.to_share {
				width: 18.75rem;
				height: 9.8rem;
			}
		}

	}

	::v-deep .van-overlay {
		backdrop-filter: blur(4px) !important;
	}
</style>


// WEBPACK FOOTER //
// src/pages/index/index.vue